var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleCalendar = function SvgGoogleCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-calendar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.369 6.633H6.632V21.37h14.737z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M21.368 27.998 28 21.366l-3.316-.565-3.316.566-.605 3.032z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#188038",
    d: "M0 21.367v4.42c0 1.222.99 2.211 2.21 2.211h4.422l.68-3.316-.68-3.315-3.613-.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1967D2",
    d: "M28 6.632V2.21A2.21 2.21 0 0 0 25.79 0h-4.422q-.605 2.468-.605 3.63 0 1.165.605 3.002 2.2.63 3.316.63T28 6.632"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M28 6.633h-6.632V21.37H28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M21.369 21.367H6.632V28h14.737z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M21.368 0H2.211A2.21 2.21 0 0 0 0 2.21v19.158h6.632V6.632h14.736z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M9.655 18.063q-.828-.557-1.14-1.634l1.278-.526q.174.663.608 1.027.432.365 1.046.363.627 0 1.077-.381.451-.382.452-.97 0-.603-.475-.984-.476-.382-1.19-.382h-.74v-1.265h.664q.613 0 1.033-.332.42-.33.42-.908 0-.514-.375-.82t-.953-.307q-.564 0-.895.3a1.76 1.76 0 0 0-.483.739l-1.265-.527q.25-.715.926-1.258.678-.545 1.728-.546.777 0 1.397.3.619.303.97.833.35.534.35 1.196 0 .676-.326 1.146a2.25 2.25 0 0 1-.801.72v.075c.41.169.765.446 1.028.802q.401.538.402 1.29 0 .751-.382 1.34a2.64 2.64 0 0 1-1.052.927q-.67.338-1.508.339a3.12 3.12 0 0 1-1.794-.557m7.852-6.344-1.403 1.015-.702-1.065 2.518-1.816h.965v8.568h-1.378z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google-calendar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgGoogleCalendar;